import React, { useState, useEffect } from 'react';
import LocationPicker from './LocationPicker';
import { TbPhotoEdit } from "react-icons/tb";
import { getDatabase, query, ref, set, get, update, remove, orderByChild, equalTo, } from 'firebase/database';
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';
import { getAuth, signOut, updatePassword, deleteUser, signInWithEmailAndPassword } from 'firebase/auth';
import defaultProfileImg from './images/plotlogo.svg';
import {
    BrowserRouter as Router,

    Link,
 
  } from "react-router-dom";
  import bird from "./images/BIRD.svg";
import panda from "./images/PANDA.svg";
import rabbit from "./images/RABBIT.svg";
import pig from "./images/PIG.svg";
import fox from "./images/FOX.svg";
import bear from "./images/BEAR.svg";
import crow from "./images/CROW.svg";
import cow from "./images/COW.svg";
import snail from "./images/SNAIL.svg";
import penguin from "./images/PENGUIN.svg";
import frog from "./images/FROG.svg";
import raccoon from "./images/RACCOON.svg";
import zebra from "./images/ZEBRA.svg";
import elephant from "./images/ELEPHANT.svg";
import axolotl from "./images/AXOLOTL.svg";


function UserProfile({handleReload, setShowFarmposts, setShowUserProfile, setIsLoading, setUserLocation, userLocation, setMobileConversationView}) {
    const [username, setUsername] = useState('');
    const [description, setDescription] = useState('');
    const [error, setError] = useState(null);
    const [showLocationPicker, setShowLocationPicker] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [profilePic, setProfilePic] = useState(null);
    const [profilePicPreview, setProfilePicPreview] = useState(null);
    const [profilePicURL, setProfilePicURL] = useState('');
    const [userTown, setUserTown] = useState('');
    const [initialUsername, setInitialUsername] = useState(null);
    const [editUsername, setEditUsername] = useState('');
    const [editDescription, setEditDescription] = useState('');
    const [editProfilePicPreview, setEditProfilePicPreview] = useState(null);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [blockedUsers, setBlockedUsers] = useState([]);
    const [activeTab, setActiveTab] = useState('profile');
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');
    const [deleteAccountPassword, setDeleteAccountPassword] = useState('');
    const [deleteAccountConfirmText, setDeleteAccountConfirmText] = useState('');
    const [defaultProfileImg, setDefaultProfileImg] = useState(null);
    

    const profileImages = [
        bird, panda, rabbit, pig, fox, bear, crow, cow, snail, penguin,
        frog, raccoon, zebra, elephant, axolotl
      ];

      function getUserIdHash(userId) {
        let hash = 0;
        for (let i = 0; i < userId.length; i++) {
            const char = userId.charCodeAt(i);
            hash = ((hash << 5) - hash) + char; // Left shift and add char
            hash |= 0; // Convert to 32bit integer
        }
        return hash;
    }
    
    function getDefaultProfileImgForUser(userId) {
        const index = Math.abs(getUserIdHash(userId)) % profileImages.length;
        return profileImages[index];
    }



 
    


    useEffect(() => {
        const unsubscribe = getAuth().onAuthStateChanged(user => {
            if (user) {
                setDefaultProfileImg(getDefaultProfileImgForUser(user.uid));
            } else {
                setDefaultProfileImg(fox);
            }
        });

        // Cleanup: Unsubscribe to the listener when the component unmounts
        return () => unsubscribe();
    }, []);


    const handleChangePassword = async () => {
        if (newPassword !== confirmNewPassword) {
            setError("New passwords don't match.");
            setTimeout(() => {
                setError(null);  // Clear the error message after 3 seconds
            }, 3000); 
            return;
        }
    
        const user = getAuth().currentUser;
        if (user) {
            try {
                await signInWithEmailAndPassword(getAuth(), user.email, currentPassword); // Verify current password
                await updatePassword(user, newPassword);
                setError("Password updated successfully.");
                
                // Clear the form
                setCurrentPassword(''); 
                setNewPassword('');
                setConfirmNewPassword('');
    
                setTimeout(() => {
                    setError(null);  // Clear the success message after 3 seconds
                }, 3000); 
            } catch (error) {
                console.error("Error updating password: ", error);
                setError("Failed to update password. Please make sure your current password is correct.");
    
                // Clear the form
                setCurrentPassword(''); 
                setNewPassword('');
                setConfirmNewPassword('');
    
                setTimeout(() => {
                    setError(null);  // Clear the error message after 3 seconds
                }, 3000); 
            }
        }
    };
    
    
    const handleDeleteAccount = async () => {
        if (deleteAccountConfirmText !== "DELETE MY ACCOUNT") {
            setError("Please type 'DELETE MY ACCOUNT' to confirm account deletion.");
            setTimeout(() => {
                setError(null);  // Clear the error message after 3 seconds
            }, 3000);
            return;
        }
    
        const user = getAuth().currentUser;
        const db = getDatabase();
    
        if (user) {
            try {
                await signInWithEmailAndPassword(getAuth(), user.email, deleteAccountPassword); // Verify password
    
                // Delete user's posts from 'farmposts'
                const farmpostsRef = ref(db, 'farmposts');
                const userPostsQuery = query(farmpostsRef, orderByChild('uid'), equalTo(user.uid));
                const userPostsSnapshot = await get(userPostsQuery);
                
                if (userPostsSnapshot.exists()) {
                    userPostsSnapshot.forEach((post) => {
                        const postRef = ref(db, `farmposts/${post.key}`);
                        remove(postRef);
                    });
                }
    
                // Anonymize user data
                const userRef = ref(db, `users/${user.uid}`);
                await update(userRef, {
                    description: "Deleted Account",
                    email: null,
                    profilePicURL: null,
                    username: "Deleted"
                });
    
                // Delete user authentication
                await user.delete();
    
                setError("Account deleted successfully. We're sorry to see you go.");
                setTimeout(() => {
                    setError(null);  // Clear the error message after 3 seconds
                }, 3000);
    
                // After deletion, handle the session/app state accordingly. You may want to redirect to the login page or a goodbye page.
            } catch (error) {
                console.error("Error deleting user: ", error);
                setError("Failed to delete account. Please make sure your password is correct.");
                setTimeout(() => {
                    setError(null);  // Clear the error message after 3 seconds
                }, 3000);
            }
        }
    };
    
    

    useEffect(() => {
        setIsLoading(true);
        const fetchUserData = async () => {
            
            const auth = getAuth();
            const user = auth.currentUser;

            if (user) {
                const db = getDatabase();
                const userRef = ref(db, `users/${user.uid}`);
                const snapshot = await get(userRef);
                // const town = await getTownFromCoordinates(userLocation.lat, userLocation.lng);


                if (snapshot.exists()) {
                    const userData = snapshot.val();
                    
                    // Fetch town after confirming user location exists in snapshot
                    // const town = userData.location && await getTownFromCoordinates(userData.location.lat, userData.location.lng);
                
                    setUsername(userData.username || '');
                    setDescription(userData.description || '');
                    setUserLocation(userData.location || '');
                    // setUserTown(town || '');
                    setProfilePicURL(userData.profilePicURL || '');
                    setInitialUsername(userData.username || null);
                    setIsDataLoaded(true);
                    setIsLoading(false);
                }
               

            }
            const fetchBlockedUsers = async () => {
                const db = getDatabase();
                const auth = getAuth();
                const user = auth.currentUser;
            
                if (!user) { // Check if user is null
                    console.warn("No user is currently signed in.");
                    return; // Exit the function early
                }
            
                const blockedUsersRef = ref(db, `users/${user.uid}/blockedUsers`);
                const snapshot = await get(blockedUsersRef);
            
                if (snapshot.exists() && snapshot.val() !== null) {
                    const blockedUserIds = Object.keys(snapshot.val());
            
                    if (blockedUserIds.length > 0) {
                        const fetchedBlockedUsers = await Promise.all(blockedUserIds.map(async uid => {
                            const userRef = ref(db, `users/${uid}`);
                            const userSnapshot = await get(userRef);
                            const userData = userSnapshot.val();
                            return {
                                uid,
                                username: userData.username || 'Unknown User'
                            };
                        }));
            
                        setBlockedUsers(fetchedBlockedUsers);
                    } else {
                        // If there are no blocked users, set blockedUsers to an empty array
                        setBlockedUsers([]);
                    }
                } else {
                    // Handle the scenario where there are no blocked users or snapshot doesn't exist
                    setBlockedUsers([]);
                }
            };
            
            fetchBlockedUsers();
        };
    
        fetchUserData();
    }, []);


useEffect(() => {
    if (isEditing) {
        setEditUsername(username);
        setEditDescription(description);
        setEditProfilePicPreview(profilePicPreview);
    }
}, [isEditing]);


    const handleUnblockUser = async (blockedUserId) => {
        const db = getDatabase();
        const auth = getAuth();
        const currentUserId = auth.currentUser.uid;
    
        const blockedUserRef = ref(db, `users/${currentUserId}/blockedUsers/${blockedUserId}`);
        await remove(blockedUserRef);
        
        setBlockedUsers(prevUsers => prevUsers.filter(user => user.uid !== blockedUserId));
    };
    
    const getTownFromCoordinates = async (lat, lng) => {
        const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY
        const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;
        const response = await fetch(apiUrl);
        const data = await response.json();
        if (data.results && data.results.length > 0) {
            const addressComponents = data.results[0].address_components;
            const townComponent = addressComponents.find(component => component.types.includes('locality'));
            return townComponent ? townComponent.long_name : null;
        }
        return null;
    };

    const handleProfilePicChange = (event) => {
        
        const file = event.target.files[0];
        if (file) {
            setProfilePic(file);

            const reader = new FileReader();
            reader.onload = (e) => {
                setEditProfilePicPreview(e.target.result);
            
            };
            reader.readAsDataURL(file);
        }
    };

    const resizeImage = (file, maxWidth, maxHeight) => {
        return new Promise((resolve, reject) => {
            if (!(file instanceof File)) {
                reject('Not a valid file');
                return;
            }
    
            const image = new Image();
            image.src = URL.createObjectURL(file);
    
            image.onload = () => {
                const canvas = document.createElement('canvas');
                const aspectRatio = image.width / image.height;
    
                let newWidth = image.width;
                let newHeight = image.height;
    
                if (image.width > image.height) {
                    newWidth = maxWidth;
                    newHeight = maxWidth / aspectRatio;
                } else {
                    newHeight = maxHeight;
                    newWidth = maxHeight * aspectRatio;
                }
    
                canvas.width = newWidth;
                canvas.height = newHeight;
    
                const ctx = canvas.getContext('2d');
                ctx.drawImage(image, 0, 0, newWidth, newHeight);
                
                canvas.toBlob((blob) => {
                    resolve(blob);
                }, 'image/jpeg', 0.8);
            };
    
            image.onerror = reject;
        });
    }

    const uploadProfilePicAndGetURL = async () => {
       
        const storage = getStorage();

        if (profilePic) {
            const resizedBlob = await resizeImage(profilePic, 400, 600);
            const storagePath = `user-profile-pics/${Date.now()}-${profilePic.name}`;
            const imageRef = storageRef(storage, storagePath);

            await uploadBytes(imageRef, resizedBlob);
            
            return await getDownloadURL(imageRef);
            
        }
        
        return null;
    };

    const handleLocationSelected = async (location) => {
      
        setUserLocation(location);
    
        // Update the database immediately when a new location is selected
        const auth = getAuth();
        const user = auth.currentUser;
    
        if (user && location) {
            const db = getDatabase();
            const userRef = ref(db, `users/${user.uid}`);
            
            await update(userRef, { location });
        
        }
    };

    function handleLogout() {
      
        const auth = getAuth();
        signOut(auth)
          .then(() => {
            setShowFarmposts(true);
            setShowUserProfile(false);
            setIsLoading(false);
            setMobileConversationView(false);
            setUserLocation(null);
            handleReload()
            // Logged out successfully
          })
          .catch((error) => {
            // Handle any errors during the logout process
            setError(error.message);
            setTimeout(() => {
                setError(null);  // Clear the error message after 3 seconds
            }, 3000); 
          });
      }

    const handleSaveProfile = async () => {
        setIsLoading(true);
        try {
            const auth = getAuth();
            const user = auth.currentUser;

            if (user) {
                const db = getDatabase();

                let updates = {
                    username,
                    description: editDescription
                };

                if (!initialUsername) {
                    const usernameRef = ref(db, `usernames/${username}`);
                    const snapshot = await get(usernameRef);
                    if (snapshot.exists()) {
                        setError('Username already taken. Please choose another.');
                        return;
                    } else {
                        await set(usernameRef, user.uid);
                        setInitialUsername(username); // Set initialUsername once username is saved
                    }
                }

                if (profilePic) {
                    const url = await uploadProfilePicAndGetURL();
                    if (url) {
                        updates.profilePicURL = url;
                        setProfilePicURL(url);
                    }
                }

                const userRef = ref(db, `users/${user.uid}`);
                await update(userRef, updates);
                setUsername(username);
        setDescription(editDescription);
        setProfilePicPreview(editProfilePicPreview);
                setIsEditing(false); // Exit edit mode after saving changes
                setError(null);
                setIsLoading(false);
            }
        } catch (err) {
            console.error(err);
            setError('There was an error updating your profile. Please try again.');
            setTimeout(() => {
                setError(null);  // Clear the error message after 3 seconds
            }, 3000); 
            setIsLoading(false);
        }
    };

    const handleSaveLocation = async () => {
        const auth = getAuth();
        const user = auth.currentUser;

        if (user && userLocation) {
            const db = getDatabase();
            const userRef = ref(db, `users/${user.uid}`);
            
            await update(userRef, { location: userLocation });
        }
    };
    if (!isDataLoaded) {
        return <div className="farmposts_size_container">
          <div className="user_profile_master_container"></div></div>;
      }

    return (
        <div className="farmposts_size_container">
        <div className="user_profile_master_container">
        <div className="tabs-nav">
    <button 
        className={activeTab === 'profile' ? 'active' : ''}
        onClick={() => setActiveTab('profile')}>
        Profile
    </button>
    <button 
        className={activeTab === 'location' ? 'active' : ''}
        onClick={() => {setActiveTab('location'); setIsEditing(false);}}>
        Location
    </button>
    <button 
        className={activeTab === 'blocked' ? 'active' : ''}
        onClick={() => {setActiveTab('blocked'); setIsEditing(false);}}>
        Block List
    </button>
    <button 
        className={activeTab === 'advanced' ? 'active' : ''}
        onClick={() => {setActiveTab('advanced'); setIsEditing(false);}}>
        Advanced
    </button>
</div>
            <div className="user_profile_active_container">


{activeTab === 'location' &&   <div className="user_profile_location_tab">

 <div className="user_profile_map"><LocationPicker onLocationSelected={handleLocationSelected} /></div>
            {userLocation && !isEditing && (
                <div className="user_profile_user_location">
                 
                    {userTown && <div>{userTown}</div>}
                    <div>{userLocation.lat.toFixed(4)}, {userLocation.lng.toFixed(4)}</div>
                    <div className="user_profile_user_location_disclaimer">Note: Your location is not shared, but it is used to find other posts near you, and to set the default location for your posts. Protect your location and make sure you trust other users before meeting.</div>
                    
                </div>
            )}
             {!userLocation && !isEditing && (
                <div className="user_profile_user_location">
                    <div>No location saved.</div>
                  
                    
                </div>
            )}
            {!isEditing && <div className="user_profile_change_location_container">
                
            <button className="user_profile_change_location_button" onClick={() => setShowLocationPicker(!showLocationPicker)}>
            
            </button>
            

            </div>}</div>}

{activeTab === 'blocked' && <div>
            {!isEditing && blockedUsers.length > 0 && (
    <div className="blocked_users_section">
        <div className="blocked_users_list">
            {/* <h4 className="blocked_users_header">Blocked Users</h4> */}
            <ul className="blocked_users_list">
                {blockedUsers.map(user => (
                    <li className="blocked_users_list_item" key={user.uid}>
                        <div className="blocked_user_username">{user.username}</div> 
                        <button className="unblock_user_button" onClick={() => handleUnblockUser(user.uid)}>Unblock</button>
                    </li>
                ))}
            </ul>
        </div>
    </div>
)}
 {!isEditing && blockedUsers.length === 0 && (
    <div className="blocked_users_section">
        <div className="blocked_users_list">
            <h4 className="blocked_users_header">No Blocked Users :)</h4>
        </div>
    </div>
)}




</div>}
                
            
            {activeTab === 'profile' && <div>{isEditing  ?  (
                <><div className="user_profile_username_container">
                    {initialUsername === null && ( <div className="user_profile_username_container">
                        <input 
                            className="user_profile_new_username_input"
                            maxLength="20"
                            type="text" 
                            value={username}
                            onChange={e => setUsername(e.target.value)}
                            placeholder="Pick a username"
                        />
                        <div className="user_profile_username_change_warning">Choose wisely, your username cannot be changed once set!</div></div>
                    )}
                     {initialUsername && (
                        <div className="user_profile_username_container_edit" >
                            {username}
                        </div>
                    )}</div>
                 
                 <div className="user_profile_profile_pic_container">
                    <div className="user_profile_profile_pic_border"> <div className="user_profile_select_profile_pic_text"><TbPhotoEdit /></div>
    <label htmlFor="profilePicInput" className="user_profile_pic_label">
    {isEditing && editProfilePicPreview ? 
    <img className="user_profile_pic" src={editProfilePicPreview} alt="Profile Preview" />
: (profilePicURL && 
    <img className="user_profile_pic" src={profilePicURL} alt="Profile" />
)}
    </label>
    <input 
        id="profilePicInput"
        type="file" 
        onChange={handleProfilePicChange}
        accept="image/*"
        style={{ display: 'none' }} // Hide the input
    />
</div></div>
                    <div className="user_profile_aboutme_container"><textarea 
                        className="user_profile_aboutme_edit_container"
                        value={editDescription}
                        onChange={e => setEditDescription(e.target.value)}
                        placeholder="About me"
                        maxLength='140'
                    />
                     <div className="user_profile_aboutme_char_count">
        {140 - editDescription.length} characters left
    </div>
                    </div>
                    
                </>
            ) : (
                <>
                    <div className="user_profile_username_container"><div className="user_profile_username_container_edit">{initialUsername ? username : <button onClick={() => setIsEditing(true)} className="user_profile_username_missing">Set a username to create posts</button>}</div></div>
                    <div className="user_profile_profile_pic_container"><div className="user_profile_profile_pic_border">
                    <img 
  className={profilePicURL ? "user_profile_pic" : "user_profile_pic_default"}
  src={profilePicURL ? profilePicURL : defaultProfileImg} 
  alt="Profile" 
  width="100" 
/>

                    </div></div>
                    <div className="user_profile_aboutme_container"><p>{description}</p></div>
                  
                </>
            )}
            {error && <div className='login_form_error_message'>{error}</div>}
            <div className="user_profile_edit_button_container">
            <button className={!isEditing ? "user_profile_edit_button" : "user_profile_save_changes"} onClick={() => isEditing ? handleSaveProfile() : setIsEditing(true)}>
                {isEditing ? 'Save Changes' : 'Edit Profile'}
                
            </button></div>
            {isEditing && <div className="user_profile_cancel_button_container"><button  className="user_profile_cancel_button" onClick={() => {setIsEditing(false); setError(null)}}>Cancel</button></div>}
            
            
            </div>}
            


            {activeTab === 'advanced' && (
    <div className="user_profile_advanced_container">
        
        {/* Change Password Section */}
        <div className="user_profile_advanced_password_section">
            <h3>Change Password</h3>
            <label>
                Current Password
                <input type="password" className="user_profile_advanced_input" value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} />
            </label>
            <label>
                New Password
                <input type="password" className="user_profile_advanced_input" value={newPassword} onChange={e => setNewPassword(e.target.value)} />
            </label>
            <label>
                Confirm New Password
                <input type="password" className="user_profile_advanced_input" value={confirmNewPassword} onChange={e => setConfirmNewPassword(e.target.value)} />
            </label>
            <button className="user_profile_advanced_btn" onClick={handleChangePassword}>Change Password</button>
        </div>
        
        {/* Delete Account Section */}
        <div className="user_profile_advanced_delete_section">
            <h3>Delete Your Account</h3>
            <p>This action is irreversible. Please proceed with caution.</p>
            <label>
                Password
                <input type="password" className="user_profile_advanced_input" value={deleteAccountPassword} onChange={e => setDeleteAccountPassword(e.target.value)} />
            </label>
            <label>
                Type "DELETE MY ACCOUNT"
                <input type="text" className="user_profile_advanced_input" value={deleteAccountConfirmText} onChange={e => setDeleteAccountConfirmText(e.target.value)} placeholder="DELETE MY ACCOUNT"/>
            </label>
            <button className="user_profile_advanced_btn user_profile_advanced_delete_btn" onClick={handleDeleteAccount}>Delete Account</button>
        </div>
        {!isEditing && <div className="user_profile_logout_button_container"><Link to="/"><button className="user_profile_logout_button" onClick={handleLogout}>Logout</button></Link></div>}
    </div>
)}



{error && <div className="create_post_error_message_container"><div className="create_post_error_message">{error ? error : ""}</div></div>}


            </div>
            
    
           
        
            
        
        
        </div></div>
    );
}

export default UserProfile;
